import * as React from 'react'
import { Tooltip, Badge, Box } from 'cs-kevlar-react'
import { CustomerDevice } from 'contexts/base'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { SL600, EL600 } from 'cs-kevlar-react/lib/es/theming/palette'

interface DeviceStatusBadgeState {
  description: string
  color: string
}

interface DeviceStatusBadgeProps {
  device: CustomerDevice
}

export const resolveStatus = (
  device: CustomerDevice,
): DeviceStatusBadgeState => {
  if (!device.pinUsed && !device.pinExpired) {
    return {
      description: `Pending - ${device.pin}`,
      color: 'transparent',
    }
  } else if (!device.pinUsed && device.pinExpired) {
    return {
      description: 'Expired',
      color: EL600,
    }
  } else if (device.pinUsed) {
    return {
      description: 'Active',
      color: SL600,
    }
  }

  return {
    description: '',
    color: 'transparent',
  }
}

const useStyles = makeStyles(_ =>
  createStyles({
    badge: {
      '& .MuiBadge-badge': {
        height: 8,
        width: 8,
        minWidth: 8,
        minHeight: 8,
        padding: 0,
        backgroundColor: (props: DeviceStatusBadgeProps) =>
          resolveStatus(props.device).color,
      } as any,
    },
  }),
)

export const DeviceStatusBadge: React.FunctionComponent<DeviceStatusBadgeProps> = ({
  device,
}) => {
  const classes = useStyles({
    device,
  })

  const status = resolveStatus(device)

  return (
    <Tooltip
      title={status.description}
      aria-label={status.description}
      placement="top"
      arrow
    >
      <Badge className={classes.badge} badgeContent="" color="primary">
        <Box />
      </Badge>
    </Tooltip>
  )
}
